import React, { useCallback, useMemo, useContext } from 'react';
import { IconButton, InputGroup, InputRightElement } from '@chakra-ui/react';
import { useDisclosure, useMergeRefs } from '@chakra-ui/hooks';
import { HiEye, HiEyeOff } from 'react-icons/hi';
import { useModule, StarberryComponentContext } from '@starberry/components';

const PasswordField = React.forwardRef(
  (
    {
      label,
      placeholder,
      name = 'password',
      required,
      value,
      defaultValue,
      onChange,
      onBlur,
      error,
      inputProps,
    },
    ref
  ) => {
    const { isOpen, onToggle } = useDisclosure();
    const inputRef = React.useRef(null);

    const mergeRef = useMergeRefs(inputRef, ref);

    const type = useMemo(() => (isOpen ? 'text' : 'password'), [isOpen]);
    const onClickReveal = useCallback(() => {
      onToggle();
      const input = inputRef.current;
      if (input) {
        input.focus({ preventScroll: true });
        const length = input.value.length * 2;
        requestAnimationFrame(() => {
          input.setSelectionRange(length, length);
        });
      }
    }, [onToggle]);

    const InputField = useModule('InputField');
    const { constants } = useContext(StarberryComponentContext);
  
    return (
      <InputGroup>
        <InputRightElement top="3px">
          <IconButton
            bg="transparent !important"
            variant="ghost"
            aria-label={isOpen ? 'Mask password' : 'Reveal password'}
            icon={isOpen ? <HiEyeOff size={24} /> : <HiEye size={24} />}
            color={constants.colors.icons}
            onClick={onClickReveal}
          />
        </InputRightElement>
        <InputField
          name={name}
          autoComplete={'current-password'}
          required={required}
          label={label}
          placeholder={placeholder}
          value={value}
          defaultValue={defaultValue}
          ref={mergeRef}
          onChange={() => onChange}
          onBlur={() => onBlur}
          error={error}
          {...inputProps}
          type={type}
        />
      </InputGroup>
    );
  }
);

export default PasswordField;
